require('./brokerSearchWidget.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const debounce = require('lodash/function/debounce');

// @components
const { OKInput } = require('commonsComponents/OKInput');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
const BrokerSearchWidgetResultList = require('components/broker/brokerSearchWidgetResultList/brokerSearchWidgetResultList');
const SearchWidgetEmptyStateRetry = require('components/broker/brokerSearchWidgetEmptyStateRetry/brokerSearchWidgetEmptyStateRetry');
const { EmptyState } = require('commonsComponents/emptyState');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling'

// @actions
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const BrokerSimpleSearchTaggingActions = require('actions/brokerSimpleSearchTagging');
const BrokerProductFiltersSearch = require('actions/brokerProductFiltersSearch');

// @constants
const {
    MYPROFILE_BROKER_EXPLORE_URL
} = require('constants/index');
const { TYPE_PLANS } = require('constants/flagBasedFeatures')

class BrokerSearchWidget extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = debounce(this.handleChange.bind(this), 700);
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleGoToAdvancedSearchClick = this.handleGoToAdvancedSearchClick.bind(this);
    }

    componentDidMount() {
        this.props.reset();
    }

    handleChange(value = '') {
        const {
            changeSearchInput,
            clearResults,
            product,
            searchProducts
        } = this.props;

        changeSearchInput(value);
        if(value.trim().length > 2) {
            searchProducts(value, product);
        } else {
            clearResults();
        }
    }

    handleRetry() {
        const term = this.props.immBrokerSearchWidget.get('search');

        this.props.searchProducts(term, this.props.product);
    }

    handleFieldChange(event) {
        this.handleChange(event.target.value);
    }

    buildTitle() {
        const title = formatText("brokerSearchWidget-title");
        return(
            <div className="broker-search-widget__title-container">
                <i className="broker-search-widget__title-search-icon icon-buscar"/>
                <span>{title}</span>
            </div>
        );
    }

    buildCloseButton() {
        return(
            <span className="broker-search-widget__title-close-icon-container">
                <button
                    className="icon-cerrar broker-search-widget__icon-cerrar"
                    onClick={() => {this.props.hideSearchWidget()}}
                ></button>
            </span>
        );
    }

    handleGoToAdvancedSearchClick() {
        const { product, immBrokerSearchWidget } = this.props;
        const productUpperCase = product ? product.toUpperCase() : false;
        const shouldSearch =
            (immBrokerSearchWidget.get('fetched') && !immBrokerSearchWidget.get('searchEmpty')) || // If the search was success
            (immBrokerSearchWidget.get('search').trim().length > 0) || // If has a term to search
            productUpperCase; // If was opened searching by specific product
        if(shouldSearch) {
            this.props.searchAdvancedProducts(productUpperCase);
        } else {
            this.props.clearAdvancedSearchResults();
        }
        this.props.simpleSearchViewAllLinkTracking();
    }

    buildFooterLink() {
        const { product } = this.props;
        const footerLink = product ? `${MYPROFILE_BROKER_EXPLORE_URL}/${this.props.product}` : MYPROFILE_BROKER_EXPLORE_URL;
        return(
            <div className="broker-search-widget__footer">
                <OKLink
                    onClick={this.handleGoToAdvancedSearchClick}
                    to={footerLink}
                    modifier="widget">
                    <FormattedText value="brokerSearchWidget-advancedSearchLink" />
                </OKLink>
            </div>
        );
    }

    buildContent() {
        const { immBrokerSearchWidget, searchAdvancedProducts, handleRetry, product } = this.props;
        const fetched = immBrokerSearchWidget.get('fetched');
        const searchEmpty = immBrokerSearchWidget.get('searchEmpty');
        const searchResultFailed = immBrokerSearchWidget.get('error');

        if(fetched){
            if (searchResultFailed) {
                return (
                    <div className="broker-search-widget__service-failed">
                        {SearchWidgetEmptyStateRetry(handleRetry)}
                    </div>
                );
            } else if(!searchEmpty) {
                const results = immBrokerSearchWidget.get('results');
                return (
                    <BrokerSearchWidgetResultList
                        searchServiceResponse={results}
                        searchEmpty={searchEmpty}
                        searchAdvancedProducts={searchAdvancedProducts}
                        simpleSearchProductLinkTracking={this.props.simpleSearchProductLinkTracking}
                        simpleSearchViewAllLinkTracking={this.props.simpleSearchViewAllLinkTracking}
                        isSpecificSearch={product}
                    />
                );
            } else {
                return (
                    <div className="broker-search-widget__no-results" >
                        <EmptyState
                            primaryText={formatText("brokerSearchWidget-brokerSearchWidget_noResultsText1")}
                            secondaryText={formatText("brokerSearchWidget-brokerSearchWidget_noResultsText2")}
                            iconType="noitems-wealth"
                        />
                    </div>
                );
            }
        }
    }

    render() {
        const { immBrokerSearchWidget, flagBasedFeatures } = this.props;
        const isVisible = immBrokerSearchWidget.get('visibility');
        const isLoading = immBrokerSearchWidget.get('isFetching');
        let content = null;
        const icon = isLoading ? <div className="Select-loading broker-search-widget__select-loading" /> : '';

        if(isVisible) {
            const placeholder = flagBasedFeatures.get(TYPE_PLANS)
                                    ? formatText("brokerSearchWidget-selectPlaceholder")
                                    : formatText("brokerSearchWidget-selectPlaceholderNoTypePlans");
            const title = this.buildTitle();
            const footer_link = this.buildFooterLink();
            const close_icon = this.buildCloseButton();
            const list = this.buildContent();

            content = (
                <ContentBox
                    customClassName={"broker-search-widget"}
                    title={title}
                    rightContent={close_icon}
                    footerContent={footer_link}
                >
                    <OKInput
                        className="broker-search-input"
                        placeholder={placeholder}
                        onChange={this.handleFieldChange}
                        autoFocus="true"
                        autoComplete={false}
                    />
                    <div className="broker-search-widget__search-icon">
                        {icon}
                    </div>
                    {list}
                </ContentBox>
            );
        }

        return content;
    }
}

BrokerSearchWidget.propTypes = {
    immBrokerSearchWidget: PropTypes.object.isRequired,
    changeSearchInput: PropTypes.func.isRequired,
    clearResults: PropTypes.func.isRequired,
    handleRetry: PropTypes.func,
    hideSearchWidget: PropTypes.func.isRequired,
    product: PropTypes.any,
    reset: PropTypes.func.isRequired,
    searchProducts: PropTypes.func.isRequired,
    searchAdvancedProducts: PropTypes.func,
    setFilterProduct: PropTypes.func,
    simpleSearchProductLinkTracking: PropTypes.func,
    simpleSearchViewAllLinkTracking: PropTypes.func,
    clearAdvancedSearchResults: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired
}

BrokerSearchWidget.defaultProps = {
    product: false
}

module.exports.constructor = BrokerSearchWidget;
module.exports.BrokerSearchWidget = connect(
    state => ({
        immBrokerSearchWidget: state.brokerSearchWidget
    }),
    {
        changeSearchInput: BrokerSearchWidgetActions.changeSearchInput,
        clearResults: BrokerSearchWidgetActions.clearResults,
        searchProducts: BrokerSearchWidgetActions.searchProducts,
        hideSearchWidget: BrokerSearchWidgetActions.hideSearchWidget,
        reset: BrokerSearchWidgetActions.reset,
        searchAdvancedProducts: BrokerSearchWidgetActions.searchAdvancedProducts,
        setFilterProduct: BrokerSearchWidgetActions.setFilterProduct,
        simpleSearchProductLinkTracking: BrokerSimpleSearchTaggingActions.simpleSearchProductLinkTracking,
        simpleSearchViewAllLinkTracking: BrokerSimpleSearchTaggingActions.simpleSearchViewAllLinkTracking,
        clearAdvancedSearchResults: BrokerProductFiltersSearch.clearResults
    }
)(withFeatureToggling(BrokerSearchWidget));
